<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <!-- {{ selection }} -->
                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-binoculars text-purple mr-1"></i>
                                        Track
                                    </div>

                                </template>

                                <p class="mt-0">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Use the filter below to search accounts for
                                                            invoices with Your Ref/PO's that
                                                            match the following criteria. Empty references will be
                                                            ignored and those already tracked.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                    <b-row class="my-2">

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Invoice Date" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="date_at" v-model="date_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="locale_ranges"
                                                        :showDropdowns="true" :linkedCalendars="true"
                                                        :single-date-picker="false" :disabled="false">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="false" @click="date_at = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                                ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12"
                                                :label="$helpers.requiredlabel(requirement, 'Client S/L')" :class="$helpers
                                                    .requiredlabel(requirement, 'Client S/L')
                                                    .slice(0, 1) == '*'
                                                    ? 'text-danger'
                                                    : ''
                                                    " label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="slac"
                                                    :clearable="true" :multiple="true" :async="true"
                                                    :load-options="treeselect_loadSLAC" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event code..."
                                                    searchPromptText="Type at least 3 chars..." v-model="eventcode"
                                                    :clearable="true" :multiple="true" :async="true"
                                                    :load-options="treeselect_loadEvent" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>


                                    <b-row v-if="checkit_result">
                                        <b-col>
                                            <b-alert :show="true" variant="warning">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6">
                                                            {{ checkit_message }}
                                                        </span>
                                                    </b-col>
                                                </b-row>
                                            </b-alert>
                                        </b-col>
                                    </b-row>



                                </p>
                            </b-tab>

                            <b-tab :disabled="slac.length == 0">
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-search text-primary mr-1"></i>
                                        Found {{ yourref.length }} item(s)
                                    </div>
                                </template>

                                <p class="mt-3">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> The reference(s) listed below are not
                                                            currently being tracked. Review the
                                                            list and remove any by clicking the 'x' if you do not want
                                                            to track them. Click Save It to add these reference(s) to
                                                            the tracking system.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Your Ref/PO" label-for="reflist2" label-cols="12">
                                                <b-input-group class="z-0">
                                                    <b-form-tags input-id="reflist2" v-model="yourref"
                                                        tag-variant="primary" separator=" ,;" placeholder="" size="sm"
                                                        class="h-29" add-button-text="+" add-on-change remove-on-delete
                                                        add-button-variant="outline-primary"></b-form-tags>
                                                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="yourref = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <b-row v-if="publishit_result">
                                        <b-col>
                                            <b-alert :show="true" variant="success">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6">
                                                            {{ publishit_message }}
                                                        </span>
                                                    </b-col>
                                                </b-row>
                                            </b-alert>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col class="text-left" cols="auto">
                                <b-button v-if="tabindex == 0" squared size="sm" variant="primary"
                                    @click="ihold_publish(false)" :disabled="slac.length == 0">
                                    <i class="fa fa-search"></i>
                                    Find It
                                </b-button>

                                <b-button v-if="tabindex == 1" class="ml-2" squared size="sm" variant="primary"
                                    @click="ihold_publish(true)"
                                    :disabled="slac.length == 0 || yourref.length == 0 || published">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                            </b-col>

                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>

                            <b-col class="text-right" cols="auto">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "OrdersTrack",
    async mounted() {
        await this.accessdenied();
        // this.ticketschange_load();
    },
    data() {
        return {
            busy: false,
            requirement: {
                slac: "Client S/L"
            },
            tabindex: 0,
            debounce: 500,
            readonly: false,
            date_at: {
                startDate: null,
                endDate: null,
            },
            slac: [],
            eventcode: [],
            yourref: [],
            message: "",
            id: null,
            published: false,
            publishit_message: "",
            publishit_result: false,
            checkit_message: "",
            checkit_result: false,
            item: {
                // from: null,
                // to: null,
                // subject: null,
                // data: null,
                // created_at: this.$moment().format("YYYY-MM-DD"),
                // updated_at: this.$moment().format("YYYY-MM-DD"),
            },
        };
    },
    watch: {
        async tabindex() {
            if (this.tabindex == 0) {
                await this.ihold_reset()
            }
        },

    },
    methods: {
        async accessdenied() {

        },
        async ihold_reset() {
            this.publishit_message = ""
            this.checkit_message = ""
            this.checkit_result = false
            this.publishit_result = false
        },
        async ihold_publish(apply) {
            this.busy = true;

            let options = ""

            let variables = {
                apply,
                options,
                yourref: this.yourref.length > 0 ? this.yourref.join(",") : null,
                slac: this.slac.length > 0 ? this.slac.join(",") : null,
                eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
                date_at: [this.date_at.startDate, this.date_at.endDate],
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query orders_track(
                                $apply: Boolean
                                $options: String
                                $slac: String
                                 $eventcode: String
                                $date_at: [String]
                                $yourref: String
                            ) {
                                orders_track (
                                    apply: $apply
                                    options: $options
                                    slac: $slac
                                    eventcode: $eventcode
                                    date_at: $date_at
                                    yourref: $yourref
                                ) {
                                    yourref
                                }                         
                        }
                            `,
                    variables,
                });

                if (response.data.orders_track) {

                    this.yourref = response.data.orders_track.map(o => o.yourref)

                    if (apply) {

                        this.publishit_message = response.data.orders_track.length + " reference(s) will now be tracked."
                        this.publishit_result = true

                    } else {

                        this.checkit_message = response.data.orders_track.length + " reference(s) are not being tracked. Review details in Found."
                        this.checkit_result = true
                        this.publishit_result = false

                    }
                    // this.message = "<span class='text-primary'>Saved it.</span>";

                }

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
            this.published = apply

            this.busy = false;
        },

    },
};
</script>